var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRemoteLogin = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 87 87",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Oval 350",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44.7576 85C66.4198 85 85 66.4198 85 44.7576C85 20.5802 66.4198 2 44.7576 2C20.5802 2 2 20.5802 2 44.7576C2 66.4198 20.5802 85 44.7576 85Z",
  fill: "white",
  stroke: "#1984EC",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M44 23C50.6285 23 56 28.316 56 34.8751H55.9995C55.9995 38.8691 54.0006 42.3939 50.947 44.5454V45.5001C50.947 46.1908 50.3817 46.7501 49.6838 46.7501H48.4207V49.2501L46.7992 50.0501C46.5892 50.1532 46.4407 50.3516 46.4044 50.5813C46.3681 50.811 46.4439 51.0423 46.6097 51.2079L48.4207 53.0001L47.1986 53.6032C46.9523 53.7282 46.796 53.9766 46.796 54.2501C46.796 54.5251 46.9523 54.7735 47.1986 54.8969L48.4207 55.5001V56.75L47.1971 57.3328C46.9492 57.4532 46.7881 57.6985 46.785 57.9704C46.7818 58.2438 46.9334 58.4938 47.1766 58.6219L48.4476 59.2813L44.6297 63L39.5788 60.5V46.7501H38.3157C37.6178 46.7501 37.0525 46.1908 37.0525 45.5001V44.5454C33.9989 42.3939 32 38.8688 32 34.8751C32 28.3156 37.3715 23 44 23ZM48.4203 32.3753C48.4203 29.9604 46.4397 28.0005 43.9994 28.0005C41.5591 28.0005 39.5786 29.9604 39.5786 32.3753C39.5786 34.7902 41.5591 36.7501 43.9994 36.7501C46.4397 36.7501 48.4203 34.7902 48.4203 32.3753Z",
  fill: "#1984EC"
}))));
export { SvgRemoteLogin as ReactComponent };
export default __webpack_public_path__ + "static/media/remoteLogin.8974da3a.svg";